<div class="sh-form-group" [class.-sh-is-invalid]="isControlInvalid$ | async" [class]="formGroupStyling">
  <sh-form-label
    [helpText]="helpText"
    [required]="isControlRequired$ | async"
    [for]="controlId"
    [labelIcons]="labelIcons"
  ></sh-form-label>

  <ng-content></ng-content>

  @if (currentActionItems) {
    <div class="sh-input-field-with-action">
      <ng-container *ngTemplateOutlet="inputField"></ng-container>
      @for (item of currentActionItems; track item) {
        <sh-action-item [item]="item" class="sh-action-group__item"> </sh-action-item>
      }
    </div>
  } @else {
    @if (canBeIndeterminate) {
      <sh-form-checkbox-with-dropdown-complex-base
        class="sh-form-group__input"
        [formControl]="control"
        [label]="label"
        [inverted]="inverted"
        [id]="controlId"
        [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        [required]="isControlRequired$ | async"
        [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
        [invalid]="isControlInvalid$ | async"
        [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        [options]="options"
        >
      </sh-form-checkbox-with-dropdown-complex-base>
    } @else {
      <sh-form-checkbox-with-dropdown-base
        class="sh-form-group__input"
        [formControl]="control"
        [label]="label"
        [inverted]="inverted"
        [id]="controlId"
        [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        [required]="isControlRequired$ | async"
        [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
        [invalid]="isControlInvalid$ | async"
        [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        [options]="options"
        >
      </sh-form-checkbox-with-dropdown-base>
    }
  }

  <ng-template #inputField>
    @if (canBeIndeterminate) {
      <sh-form-checkbox-with-dropdown-complex-base
        class="sh-form-group__input"
        [formControl]="control"
        [label]="label"
        [inverted]="inverted"
        [id]="controlId"
        [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        [required]="isControlRequired$ | async"
        [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
        [invalid]="isControlInvalid$ | async"
        [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        [options]="options"
        >
      </sh-form-checkbox-with-dropdown-complex-base>
    } @else {
      <sh-form-checkbox-with-dropdown-base
        class="sh-form-group__input"
        [formControl]="control"
        [label]="label"
        [inverted]="inverted"
        [id]="controlId"
        [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        [required]="isControlRequired$ | async"
        [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
        [invalid]="isControlInvalid$ | async"
        [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
        [options]="options"
        >
      </sh-form-checkbox-with-dropdown-base>
    }
  </ng-template>



  @if (isControlInvalid$ | async) {
    <p [id]="describeLabelId" class="sh-form-group__feedback">{{ errorMsg }}</p>
  }
</div>
